<template>
  <div>
    <app-modal-entrada :content="content" :documentoId="documentoId" v-if="showModalAdd"></app-modal-entrada>
    <el-form @submit.native.prevent="save" ref="form" label-position="top" id="documental">
      <el-row type="flex" justify="space-between">
        <el-col :span="6">
          <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
            <el-input v-model="template.title"></el-input>
            <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
          </el-form-item>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="6">
          <el-form-item label="Tipo de listado">
            <select class="select" v-model="template.tipo">
              <option value="1">Tabla</option>
              <option value="2">Galería</option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="4">
          <el-form-item label="Buscador">
            <el-radio-group v-model="template.search">
              <el-radio-button :label="1">Sí</el-radio-button>
              <el-radio-button :label="2">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="5">
          <el-form-item label="Toggle">
            <el-radio-group v-model="template.toggle">
              <el-radio-button :label="1">Abierto</el-radio-button>
              <el-radio-button :label="2">Cerrado</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <el-form-item label="Texto descriptivo del listado" v-if="showEditor">
            <app-vue-editor :value="template.description"></app-vue-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template v-if="content">
      <button @click="addItem()" class="el-button el-button--primary">
        <span>Añadir documento</span>
        <i class="el-icon-circle-plus"></i>
      </button>
      <br />
      <br />
      <app-modal-draggable
        v-if="modalDraggable"
        :content="fecthItems"
        :name="'title'"
        :table="'documental_documentos'"
      ></app-modal-draggable>

      <app-table-paginate
        v-if="fecthItems.length > 0"
        :routeEdit="routeEdit"
        :routeDelete="routeDelete"
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :draggable="true"
        :move="true"
      ></app-table-paginate>
    </template>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import entrada from "@/components/Dashboard/Modals/addDocumento";
import tablaConPaginadorVue from "@/components/_commons/tablaConPaginador";
import { API_UPLOADS } from "@/common/config";
import Draggable from "@/components/Dashboard/Modals/draggable";
import Editor from "@/components/_commons/vue-editor";

export default {
  name: "listado",
  props: ["content"],
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-entrada": entrada,
    "app-modal-draggable": Draggable,
    "app-vue-editor": Editor
  },
  created() {
    this.routeEdit = "modal";
    this.routeDelete = "documentalDocumento";
    if (this.content) {
      this.getTableData();
      this.getContent();
    }

    this.$root.$on("openModal", id => {
      setTimeout(() => {
        this.addItem(id);
      }, 300);
    });
    this.$root.$on("closeModal", () => {
      this.showModalAdd = false;
      this.getTableData();
    });
    this.$root.$on("saveContent", id => {
      this.id = id;
      this.section_id = id;
      this.setSave();
    });

    this.$root.$on("documentalDocumento", id => {
      this.eliminarRegistro(id);
    });
    this.$root.$on("draggable", e => this.showDraggable());
    this.$root.$on("closeModal", () => this.closeModal());
    this.$root.$on("vue-editor", e => {
      this.template.description = e;
    });
  },
  watch: {
    $route(to) {
      if (this.content) this.getContent();
    }
  },
  data() {
    return {
      table: "documental",
      template: {
        title: "",
        description: "",
        search: 2,
        toggle: 1,
        tipo: 1
      },
      errorTitle: false,
      message: false,
      id: false,
      tableColumns: [
        {
          prop: "title",
          label: "Título"
        },
        {
          prop: "file",
          label: "Documento",
          type: "file"
        },
        {
          prop: "check_leido",
          label: "Conf. lectura",
          type: "switch"
        },
        {
          prop: "link",
          label: "link"
        },
        {
          prop: "date",
          label: "Fecha"
        }
      ],
      tableQuery: {},
      tableData: [],
      routeEdit: null,
      deleterow: false,
      showModalAdd: false,
      api_uploads: API_UPLOADS,
      documentoId: false,
      modalDraggable: false,
      showEditor: false
    };
  },
  methods: {
    async getContent() {
      const a = await ApiService.post("dashboard/table", {
        table: "documental",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.content
      });
      this.template = a.data;
      this.showEditor = true;
    },
    async getTableData() {
      this.tableData = [];

      const a = await ApiService.post(
        "dashboard/listtabledocumentalycontents",
        {
          table: "documental_documentos",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          documental_id: this.content
        }
      );
      if (a.data !== "Algo ha fallado") {
        this.tableData = a.data.filter(data => {
          data.url = this.api_uploads + data.url;
          data.file = this.api_uploads + data.file;

          data.move =
            "/dashboard/" +
            this.$route.params.db +
            "/form/edit/documentos/" +
            data.id;
          return data;
        });
      }
    },
    setSave() {
      this.content != 0 ? this.update() : this.insert();
    },
    async update() {
      await ApiService.post("dashboard/editform", {
        table: "documental",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template,
        id: this.content
      });
    },
    async insert() {
      const a = await ApiService.post("dashboard/editform", {
        table: "documental",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template
      });
      if (a.status === 200) {
        const b = await ApiService.post("dashboard/editform", {
          table: "contents",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: {
            template_id: 3,
            registro_id: a.data
          }
        });
        if (b.status === 200) {
          await ApiService.post("dashboard/editform", {
            table: "sections_contents",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            form: {
              section_id: this.section_id,
              content_id: b.data
            }
          });
        }
      }
    },
    addItem(id = null) {
      this.documentoId = id;
      this.showModalAdd = !this.showModalAdd;
    },
    async eliminarRegistro(id) {
      const a = await ApiService.post("dashboard/delete", {
        table: "documentos",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id
      });
      if (a.status === 200) {
        this.deleterow = a.data;
        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente"
          });
          this.getTableData();
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow
          });
        }
        this.getTableData();
      }
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.getTableData();
    }
  },
  computed: {
    fecthItems() {
      return this.tableData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/documental.vue